import React, { memo } from 'react';
const categories = [{
  categoryTitle: '🧠 Estimulación Cognitiva',
  items: [{
    icon: '📘',
    title: 'Volumen 1 · Lenguaje y Comunicación',
    desc: '50 actividades diseñadas para fortalecer el vocabulario, la comprensión lectora, la escritura y la comunicación cotidiana mediante sopas de letras, crucigramas, asociaciones de palabras y ejercicios progresivos de lenguaje.'
  }, {
    icon: '📘',
    title: 'Volumen 2 · Memoria y Atención',
    desc: 'Entrena la memoria visual, auditiva y la capacidad de concentración con 50 actividades que ayudan a reducir los olvidos, mejorar la atención y mantener la mente activa día tras día.'
  }, {
    icon: '📘',
    title: 'Volumen 3 · Razonamiento y Lógica',
    desc: 'Ejercicios prácticos para desarrollar el pensamiento lógico, el cálculo mental, la resolución de problemas, las secuencias y la capacidad de análisis aplicada a situaciones de la vida diaria.'
  }, {
    icon: '📘',
    title: 'Volumen 4 · Orientación Temporal',
    desc: '50 actividades para reforzar el reconocimiento de días, meses, estaciones, horarios y rutinas, favoreciendo una mejor organización del tiempo y mayor autonomía.'
  }, {
    icon: '📘',
    title: 'Volumen 5 · Orientación Espacial',
    desc: 'Ejercicios orientados a mejorar la percepción del entorno, la ubicación, los recorridos, la lateralidad y la orientación espacial para desplazarse con mayor seguridad.'
  }, {
    icon: '⭐',
    title: 'Programa Premium · Plan Guiado de 90 Días',
    desc: 'El corazón del sistema de estimulación cognitiva. Un programa completamente organizado con 90 sesiones listas para aplicar, donde cada día combina ejercicios mentales, actividades funcionales y bienestar emocional para mantener la mente activa sin tener que improvisar.',
    highlight: true
  }]
}, {
  categoryTitle: '🚶 Estimulación Física',
  items: [{
    icon: '📗',
    title: 'Volumen 1 · Movilidad, Equilibrio y Prevención de Caídas',
    desc: 'Manual práctico con rutinas de movilidad articular, ejercicios en silla y de pie, fortalecimiento muscular, equilibrio, coordinación y estrategias para reducir el riesgo de caídas dentro del hogar.'
  }, {
    icon: '📗',
    title: 'Volumen 2 · Guía Práctica para el Cuidado del Adulto Mayor',
    desc: 'Aprende a organizar el cuidado diario con recomendaciones prácticas para acompañar a adultos mayores con Alzheimer, Parkinson, diabetes e hipertensión, además de pautas de comunicación, organización y acompañamiento seguro.'
  }, {
    icon: '📗',
    title: 'Volumen 3 · Bitácora Integral de Salud y Seguimiento',
    desc: 'Planner imprimible con registros de medicación, presión arterial, glucemia, alimentación, sueño, actividad física, citas médicas y evolución diaria para llevar un control organizado del cuidado.'
  }, {
    icon: '📗',
    title: 'Volumen 4 · Manual Integral para Familiares y Cuidadores',
    desc: 'Una guía completa para prevenir el agotamiento del cuidador, organizar responsabilidades, mejorar la comunicación familiar y cuidar también del bienestar físico y emocional de quien acompaña al adulto mayor.'
  }]
}, {
  categoryTitle: '🎁 Bonos Exclusivos',
  items: [{
    icon: '🎁',
    title: 'Bono 1 · Calendario de 30 Días de Ejercicios Cognitivos',
    desc: 'Un calendario listo para usar con actividades organizadas día por día que ayudan a crear el hábito de ejercitar la mente de forma constante y sencilla.'
  }, {
    icon: '🎲',
    title: 'Bono 2 · Juegos Interactivos para Gimnasia Cerebral',
    desc: 'Colección de juegos imprimibles para estimular memoria, atención, lenguaje y razonamiento de manera entretenida, ideal para realizar en familia, talleres o sesiones terapéuticas.'
  }, {
    icon: '✍️',
    title: 'Bono 3 · Cuaderno de Estimulación Emocional',
    desc: 'Ejercicios guiados de gratitud, recuerdos positivos y escritura terapéutica para fortalecer el bienestar emocional, la autoestima y la motivación del adulto mayor.'
  }]
}];
export function ModulesSection() {
  return <section className="w-full bg-sky py-20 px-4 sm:px-8 lg:px-12 pb-[0px]" data-id="element-48">
      <div className="max-w-6xl mx-auto" data-id="element-49">
        <div className="text-center mb-16" data-id="element-50">
          <h2 className="font-serif text-navy text-3xl md:text-5xl font-bold mb-6" data-id="element-51">
            Todo lo que incluye el{' '}
            <span className="text-[#FF811B]" data-id="element-52">Super Pack</span>
          </h2>
          <p className="text-navy/70 text-lg max-w-2xl mx-auto" data-id="element-53">
            Un programa estructurado, directo al grano y en letra grande,
            diseñado para que lo apliques desde hoy mismo.
          </p>
        </div>

        <div className="space-y-16" data-id="element-54">
          {categories.map((category, catIdx) => <div key={catIdx} data-id="element-55">
              <h3 className="text-2xl md:text-3xl font-bold text-navy mb-8 border-b border-navy/10 pb-4" data-id="element-56">
                {category.categoryTitle}
              </h3>

              {/* Grid: 1 columna en móvil, 2 en desktop para tarjetas horizontales */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6" data-id="element-57">
                {category.items.map((mod, idx) => {
              if (mod.highlight) {
                return <div key={idx} className="bg-navy border border-gold/40 rounded-2xl p-5 md:p-6 relative overflow-hidden shadow-panel flex flex-row gap-4 md:gap-6 items-start lg:col-span-2" data-id="element-58">
                        <div className="absolute top-0 right-0 bg-gold text-navy-deep text-[10px] md:text-xs font-bold px-2 py-1 md:px-3 rounded-bl-lg" data-id="element-59">
                          MÓDULO VIP
                        </div>
                        <div className="text-4xl md:text-5xl flex-shrink-0 mt-1 md:mt-2" data-id="element-60">
                          {mod.icon}
                        </div>
                        <div className="flex-1" data-id="element-61">
                          <h4 className="text-gold font-bold text-base md:text-xl mb-1 md:mb-2 pr-16 md:pr-20" data-id="element-62">
                            {mod.title}
                          </h4>
                          <p className="text-gray-300 text-sm md:text-base leading-relaxed" data-id="element-63">
                            {mod.desc}
                          </p>
                        </div>
                      </div>;
              }
              return <div key={idx} className="bg-white border border-navy/10 rounded-2xl p-5 md:p-6 shadow-panel hover:-translate-y-1 hover:border-coral/50 transition-all duration-300 flex flex-row gap-4 items-start" data-id="element-64">
                      <div className="text-3xl md:text-4xl flex-shrink-0 mt-1" data-id="element-65">
                        {mod.icon}
                      </div>
                      <div className="flex-1" data-id="element-66">
                        <h4 className="text-navy font-bold text-base md:text-lg mb-1 md:mb-2 leading-tight" data-id="element-67">
                          {mod.title}
                        </h4>
                        <p className="text-navy/60 text-sm md:text-base leading-relaxed" data-id="element-68">
                          {mod.desc}
                        </p>
                      </div>
                    </div>;
            })}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}